import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ProgramareSloturiUltimaOra, ProgramareSloturiUltimaOraUpdate, SlotGrupUpdate, SlotGrupKey } from './programari-ultima-ora.interface';

@Injectable({
    providedIn: 'root'
})
export class ProgramariUltimaOraService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private baseApiPath = this.basePath + 'api/programari/nomenclatoare/ultima-ora-zi/';

    private storeProgramareSloturiUltimaOraUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.programariSloturiUltimaOra.storeProgramareSloturiUltimaOra;
    private updateProgramareSloturiUltimaOraUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.programariSloturiUltimaOra.updateProgramareSloturiUltimaOra;
    private deleteProgramareSloturiUltimaOraUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.programariSloturiUltimaOra.deleteProgramareSloturiUltimaOra;

    // URL-uri pentru grupuri
    private listGroupedUrl = this.baseApiPath + 'list-dt-grouped';
    private updateGroupUrl = this.baseApiPath + 'update-group';
    private deleteGroupUrl = this.baseApiPath + 'delete-group';

    constructor(private http: HttpClient) { }

    addProgramareSloturiUltimaOra(programareSloturiUltimaOra: ProgramareSloturiUltimaOra) {
        return this.http.post(this.storeProgramareSloturiUltimaOraUrl, programareSloturiUltimaOra, this.httpOptions);
    }

    updateProgramareSloturiUltimaOra(programareSloturiUltimaOra: ProgramareSloturiUltimaOraUpdate) {
        return this.http.put(this.updateProgramareSloturiUltimaOraUrl, programareSloturiUltimaOra, this.httpOptions);
    }

    deleteProgramareSloturiUltimaOra(id: number) {
        return this.http.delete(this.deleteProgramareSloturiUltimaOraUrl + id);
    }

    // Metode pentru grupuri
    getGroupedList(params: any) {
        return this.http.post(this.listGroupedUrl, params, this.httpOptions);
    }

    updateGroup(group: SlotGrupUpdate) {
        return this.http.put(this.updateGroupUrl, group, this.httpOptions);
    }

    deleteGroup(groupKey: SlotGrupKey) {
        return this.http.post(this.deleteGroupUrl, groupKey, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
